import VestingSchedule from "@/seed/components/elements/vesting-schedule";
import { data as popupConfig } from "./popup-msg";
import { data as seedRoundData } from "@/seed/shared/token/seed-round/round-info";

export const data = {
    approveSuccess: {
        popupMsgType: popupConfig.popupMsgType.success,
        title: "transaction submitted",
        bscScanBtn: {
            title: "View on BSC Scan",
            // link: "https://bscscan.com/",
            target: "_blank",
        },
        msg: "Please be patient and no need to approve again, You can view the transaction status on Block Explorer",
    },
    commonFailure: {
        popupMsgType: popupConfig.popupMsgType.fail,
        title: "something is wrong",
        bscScanBtn: {
            title: "View on BSC Scan",
            // link: "https://bscscan.com/",
            target: "_blank",
        },
        msg: "Error message",
    },
    purchaseSuccess: {
        popupMsgType: popupConfig.popupMsgType.success,
        title: "transaction submitted",
        bscScanBtn: {
            title: "View on BSC Scan",
            // link: "https://bscscan.com/",
            target: "_blank",
        },
        msg: "Please be patient and no need to Purchase again, You can view the transaction status on Block Explorer",
    },
    claimToken: {
        popupMsgType: popupConfig.popupMsgType.success,
        title: "You can claim",
        // desc: "40,000,000",
        // subDesc: "MDN",
        image: {
            img: "/img/mdn-token@3x.webp",
            width: 90,
            height: 98,
        },
        customBtn: {
            title: "Claim now",
        },
    },
    claimTokenSuccess: {
        popupMsgType: popupConfig.popupMsgType.success,
        title: "You have claimed",
        // desc: "40,000,000",
        // subDesc: "MDN",
        isSpecialBg: true,
        image: {
            img: "/img/mdn-token@3x.webp",
            width: 90,
            height: 98,
        },
    },
    claimTokenLoading: {
        title: "Claiming...",
        // desc: "40,000,000",
        // subDesc: "MDN",
        loading: true,
        msg: "You were unable to complete the claiming. Please try again",
    },
    claimTokenFail: {
        popupMsgType: popupConfig.popupMsgType.fail,
        title: "Opps! something\nwent wrong",
        customBtn: {
            title: "Try again",
        },
        msg: "You were unable to complete the claiming. Please try again",
    },
    vesting: {
        customContent: {
            contentType: popupConfig.customContentType.vestingSchedule,
            renderContent: (vestingSchedule) => {
                return <VestingSchedule data={vestingSchedule} />;
            },
        },
    },
};
